import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { ERoutes } from '../enums/routes.enum';

import { LinkService } from 'src/app/core/services/link.service';

@Injectable({
  providedIn: 'root',
})
export class MetaTagsConfigService {
  private metaTags = {
    'country-info-title':
      "Routeperfect's Guide to Countries, Regions & Cities - Explore Top Travel Destinations and Hidden Gems with Our Easy-to-Use Trip Planner",
    'country-info-og:title':
      "Routeperfect's Guide to Countries, Regions & Cities - Explore Top Travel Destinations and Hidden Gems with Our Easy-to-Use Trip Planner",
    'country-info-og:description':
      "Explore Routeperfect's comprehensive guide to countries, regions, and cities. Discover top travel destinations and hidden gems with our easy-to-use trip planner, linking you to detailed travel information for every location.",
    'country-info-keywords': '',
    'country-info-description':
      "Explore Routeperfect's comprehensive guide to countries, regions, and cities. Discover top travel destinations and hidden gems with our easy-to-use trip planner, linking you to detailed travel information for every location.",

    'home-view-title':
      'Plan & Book A Perfect Trip With Our Itinerary Planner - RoutePerfect',
    'home-view-og:title': 'RoutePerfect - Create your perfect trip',
    'home-view-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'home-view-keywords':
      'Italy trip planning, Italy itinerary, places to visit in italy, things to do in Italy, italy trip, italy route, France trip planning, France itinerary, places to visit in France, things to do in France, France trip, France route, Europe trip planning, Europe itinerary, places to visit in Europe, things to do in Europe, Europe trip, Europe route',
    'home-view-description':
      'The ultimate tool to plan and book your best trip. Easily create your perfect tour based on your preferences, budget and style!',

    'about-us-title': 'About RoutePerfect - Create your perfect trip',
    'about-us-og:title': 'About RoutePerfect - Create your perfect trip',
    'about-us-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'about-us-keywords':
      'Italy trip planning, Italy itinerary, places to visit in italy, things to do in Italy, italy trip, italy route, France trip planning, France itinerary, places to visit in France, things to do in France, France trip, France route, Europe trip planning, Europe itinerary, places to visit in Europe, things to do in Europe, Europe trip, Europe route',
    'about-us-description':
      'RoutePerfect is a free interactive trip planning tool that helps you easily create a custom European trip plan based on your personal preferences.',

    'press-title': 'RoutePerfect Press Releases',
    'press-og:title': 'RoutePerfect Press Releases and News',
    'press-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'press-keywords':
      'Italy trip planning, Italy itinerary, places to visit in italy, things to do in Italy, italy trip, italy route, France trip planning, France itinerary, places to visit in France, things to do in France, France trip, France route, Europe trip planning, Europe itinerary, places to visit in Europe, things to do in Europe, Europe trip, Europe route',
    'press-description':
      'RoutePerfect is a free interactive trip planning tool that helps you easily create a custom European trip plan based on your personal preferences.',

    'our-team-title': 'About RoutePerfect - Create your perfect trip',
    'our-team-og:title': 'RoutePerfect - Create your perfect trip',
    'our-team-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'our-team-keywords':
      'Italy trip planning, Italy itinerary, places to visit in italy, things to do in Italy, italy trip, italy route, France trip planning, France itinerary, places to visit in France, things to do in France, France trip, France route, Europe trip planning, Europe itinerary, places to visit in Europe, things to do in Europe, Europe trip, Europe route',
    'our-team-description':
      'RoutePerfect is a free interactive trip planning tool that helps you easily create a custom European trip plan based on your personal preferences.',

    'trip-testimonials-title':
      'Testimonials - RoutePerfect - Create your perfect trip',
    'trip-testimonials-og:title':
      'Testimonials - RoutePerfect - Create your perfect trip',
    'trip-testimonials-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'trip-testimonials-keywords':
      'Italy trip planning, Italy itinerary, places to visit in italy, things to do in Italy, italy trip, italy route, France trip planning, France itinerary, places to visit in France, things to do in France, France trip, France route, Europe trip planning, Europe itinerary, places to visit in Europe, things to do in Europe, Europe trip, Europe route',
    'trip-testimonials-description':
      'RoutePerfect is a free interactive trip planning tool that helps you easily create a custom European trip plan based on your personal preferences.',

    'terms-of-use-title':
      'Terms of use for RoutePerfect - Create your perfect trip',
    'terms-of-use-og:title': 'RoutePerfect - Create your perfect trip',
    'terms-of-use-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'terms-of-use-keywords':
      'Europe trip plan, Europe trip planning, Europe route, Europe itinerary, trip in Europe',
    'terms-of-use-description':
      'RoutePerfect terms of use. RoutePerfect,  personalized Europe trip planning tool.',

    'privacy-policy-title':
      'Privacy policy for RoutePerfect - Create your perfect trip',
    'privacy-policy-og:title': 'RoutePerfect - Create your perfect trip',
    'privacy-policy-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'privacy-policy-keywords':
      'Europe trip plan, Europe trip planning, Europe route, Europe itinerary, trip in Europe',
    'privacy-policy-description':
      'RoutePerfect privacy policy. RoutePerfect,  personalized Europe trip planning tool.',

    'contact-us-title': 'Contact RoutePerfect - Create your perfect trip',
    'contact-us-og:title': 'RoutePerfect - Create your perfect trip',
    'contact-us-og:description':
      'If you need help or have suggestions please contact us. RoutePerfect, personalized Europe trip planning tool.',
    'contact-us-keywords':
      'Italy trip planning, Italy itinerary, places to visit in italy, things to do in Italy, italy trip, italy route, France trip planning, France itinerary, places to visit in France, things to do in France, France trip, France route, Europe trip planning, Europe itinerary, places to visit in Europe, things to do in Europe, Europe trip, Europe route',
    'contact-us-description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',

    'affiliates-title': 'RoutePerfect Affiliate program',
    'affiliates-og:title': 'RoutePerfect - Create your perfect trip',
    'affiliates-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'affiliates-keywords':
      'affiliate, commission, offer, affiliate program, advertise',
    'affiliates-description':
      'Join RoutePerfect Affiliate program and earn high commissions for every sale!',

    'my-trips-title': 'My trips - RoutePerfect',
    'my-trips-og:title': 'RoutePerfect - Look your saves trip',
    'my-trips-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'my-trips-keywords': '',
    'my-trips-description': '',

    'settings-title': 'Personal settings - RoutePerfect',
    'settings-og:title': 'RoutePerfect - Configure your personal settings',
    'settings-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'settings-keywords': '',
    'settings-description': '',

    'trip-planner-title':
      'Tour Planner - Plan a Perfect Trip with Our Itinerary Planner',
    'trip-planner-og:title': 'RoutePerfect - Create your perfect trip',
    'trip-planner-og:description':
      'Plan a trip with RoutePerfect’s tour planner. Easily create your perfect trip itinerary based on your preferences, budget and travel style!',
    'trip-planner-keywords':
      'italy map, italy trip planning, italy itinerary, italy trip plan, italy route, France map, France trip planning, France itinerary, France trip plan, France route map, France trip planning, France itinerary, France trip plan, France route, Europe map, Europe trip planning, Europe itinerary, Europe trip plan, Europe route map, Europe trip planning, Europe itinerary, Europe trip plan, Europe route',
    'trip-planner-description':
      'Plan a trip with RoutePerfect’s tour planner. Easily create your perfect trip itinerary based on your preferences, budget and travel style!',

    'top-itinerary-title':
      'Our Most Popular European Trip Itineraries - RoutePerfect',
    'top-itinerary-og:title': 'RoutePerfect - Our most popular trips',
    'top-itinerary-og:description': '',
    'top-itinerary-keywords': '',
    'top-itinerary-description': '',

    'top-itineraries-title':
      'Our Most Popular European Trip Itineraries - RoutePerfect',
    'top-itineraries-og:title': 'RoutePerfect - Create your perfect trip',
    'top-itineraries-og:description':
      'Planning your trip? Not sure where to start? Try our suggested Itineraries for romantic, family, friends or solo trips. Start planning your perfect trip today!',
    'top-itineraries-keywords':
      'Italy trip planning, Italy itinerary, places to visit in italy, things to do in Italy, italy trip, italy route, France trip planning, France itinerary, places to visit in France, things to do in France, France trip, France route, Europe trip planning, Europe itinerary, places to visit in Europe, things to do in Europe, Europe trip, Europe route',
    'top-itineraries-description':
      "Planning a European honeymoon or a foodie's adventure? Check out the most popular European itineraries on RoutePerfect as basis for your trip!",

    'customize-package-title':
      'Customize Your Package - Trip Planning Tool & Travel Shop',
    'customize-package-og:title': 'RoutePerfect - Create your perfect trip',
    'customize-package-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style.',
    'customize-package-keywords':
      'travel, trip, trip plan, visit, itinerary, vacation, holiday, explore, discover, book, price, package, deal, buy, purchase, reservation, reserve, booking',
    'customize-package-description':
      'Create custom trip itineraries and package deals based on your travel preferences, budget & style.',

    'browse-hotels-title': 'Hotel Selection - Trip Planning Tool & Travel Shop',
    'browse-hotels-og:title':
      'RoutePerfect - Trip Planning Tool & Travel Shop!',
    'browse-hotels-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style.',
    'browse-hotels-keywords':
      'travel, trip, trip plan, visit, itinerary, vacation, holiday, explore, discover, book, price, package, deal, buy, purchase, reservation, reserve, booking, hotels, hotel selection, browse',
    'browse-hotels-description':
      'Create your own trip package deal & choose where you stay based on your travel preferences, budget & style.',

    'countries-title':
      'Countries of RoutePerfect - Trip Planning Tool & Travel Shop',
    'countries-og:title': 'RoutePerfect - Create your perfect trip',
    'countries-og:description':
      'RoutePerfect is an online trip planning tool that helps you create a custom trip itinerary based on your travel preferences, budget and personal style. Start planning the perfect trip today!',
    'countries-keywords':
      'places to visit in europe, things to do in europe, europe trip plan, europe trip planning, europe route, europe itinerary',
    'countries-description':
      'Join RoutePerfect Affiliate program and earn high commissions for every sale!',

    'view-trip-keywords':
      'places to visit in Europe, things to do in Europe, Europe trip plan, Europe trip planning, Europe route, Europe itinerary, family itinerary to Europe, family trip plan to Europe, romantic trip in Europe, honeymoon in Europe',
  };

  private readonly URL = 'https://www.routeperfect.com';
  private readonly titleTag = '-title';
  private readonly ogTitleTag = '-og:title';
  private readonly ogDescriptionTag = '-og:description';
  private readonly descriptionTag = '-description';

  constructor(
    private linkService: LinkService,
    private meta: Meta,
    private title: Title,
    private route: ActivatedRoute,
  ) {}

  public getMetaTagText(key: string): any {
    return this.metaTags[key];
  }

  public setMetaTags(pageName: string): void {
    const hardCodedUrl = this.URL + this.route.snapshot['_routerState'].url;
    const href = this.fixCanonicalUrlView(hardCodedUrl);

    this.linkService.addTag({ rel: 'canonical', href: href });
    this.title.setTitle(this.getMetaTagText(pageName + this.titleTag));
    this.removeMetaTags();
    this.meta.addTags([
      {
        name: 'description',
        content: this.getMetaTagText(pageName + this.descriptionTag),
      },
      {
        name: 'title',
        content: this.getMetaTagText(pageName + this.ogTitleTag),
      },
      { property: 'og:url', content: href },
      {
        property: 'og:title',
        content: this.getMetaTagText(pageName + this.ogTitleTag),
      },
      {
        property: 'og:description',
        content: this.getMetaTagText(pageName + this.ogDescriptionTag),
      },
    ]);
  }

  public removeNoIndexMetaTag(): void {
    this.meta.removeTag("content='noindex'");
  }

  public setMetaTagsDynamically(
    pageName: string,
    dynamicDescription: string,
    dynamicTitle: string,
  ): void {
    const hardCodedUrl = this.URL + this.route.snapshot['_routerState'].url;
    const href = this.fixCanonicalUrlView(hardCodedUrl);

    this.linkService.addTag({ rel: 'canonical', href: href });
    this.title.setTitle(dynamicTitle);

    this.removeMetaTags();
    this.meta.addTags([
      { name: 'description', content: dynamicDescription },
      { name: 'title', content: dynamicTitle },
      { property: 'og:url', content: href },
      { property: 'og:title', content: dynamicTitle },
      { property: 'og:description', content: dynamicDescription },
    ]);
  }

  public removeMetaTags(): void {
    this.meta.removeTag("name='title'");
    this.meta.removeTag("name='description'");
    this.meta.removeTag("property='og:url'");
    this.meta.removeTag("property='og:title'");
    this.meta.removeTag("property='og:description'");
    this.meta.removeTag("content='noindex'");
  }

  public setNoIndexMetaTag() {
    this.meta.addTag({ name: 'robots', content: 'noindex' });
  }

  public setPrerenderErrorMetaTag(errorCode: number): void {
    switch (errorCode) {
      case 404: {
        this.meta.addTag({ name: 'prerender-status-code', content: '404' });
        break;
      }
      default: {
        break;
      }
    }
  }

  public removePrerenderErrorMetaTag(): void {
    this.meta.removeTag("name='prerender-status-code'");
  }

  private fixCanonicalUrlView(url: string): string {
    let fixedUrl = String(url);
    if (url.includes(ERoutes.TRIP_PLANNER)) {
      fixedUrl = url.includes('?id') ? url.split('?id')[0] : url;
      const clearId = url.split(ERoutes.TRIP_PLANNER)[1];

      if (clearId.length === 9) {
        fixedUrl = url.replace(clearId, '');
        this.setNoIndexMetaTag();
      }
    }

    const decodedUri = decodeURI(fixedUrl);
    return decodedUri.replace(/ /g, '-').toLowerCase();
  }

  public setCountrySeoTags(countryName: string): void {
    const formattedCountry = countryName.toLowerCase().replace(/ /g, '-');
    const url = `${this.URL}/${formattedCountry}`;
    const title = `Plan your Trip to ${countryName} - Free ${countryName} trip planner`;
    const description = `Discover ${countryName}’s top destinations, regions, and cities with Routeperfect. Explore detailed information about ${countryName}’s highlights and hidden gems to enhance your travel plans.`;

    this.setMetaTagsDynamically(countryName, description, title);
    this.linkService.addTag({ rel: 'canonical', href: url });
  }

  public setRegionSeoTags(regionName: string, countryName: string): void {
    const formattedRegion = regionName.toLowerCase().replace(/ /g, '-');
    const formattedCountry = countryName.toLowerCase().replace(/ /g, '-');
    const url = `${this.URL}/${formattedCountry}/${formattedRegion}`;
    const title = `Plan your Trip to ${regionName} ${countryName} - Free ${regionName} trip planner`;
    const description = `Discover ${regionName}’s top destinations and cities with Routeperfect. Explore detailed information about ${regionName}’s highlights and hidden gems to enhance your travel plans.`;

    this.setMetaTagsDynamically(regionName, description, title);
    this.linkService.addTag({ rel: 'canonical', href: url });
  }

  public setCitySeoTags(
    cityName: string,
    regionName: string,
    countryName: string,
  ): void {
    const formattedCity = cityName.toLowerCase().replace(/ /g, '-');
    const formattedRegion = regionName.toLowerCase().replace(/ /g, '-');
    const formattedCountry = countryName.toLowerCase().replace(/ /g, '-');
    const url = `${this.URL}/${formattedCountry}/${formattedRegion}/${formattedCity}`;
    const title = `Plan your Trip to ${cityName} ${countryName} - Free ${cityName} trip planner`;
    const description = `Explore ${cityName} with Routeperfect. Find top attractions, hotels, local events, and more to make the most of your visit to ${cityName}. Discover everything ${cityName} has to offer.`;

    this.setMetaTagsDynamically(cityName, description, title);
    this.linkService.addTag({ rel: 'canonical', href: url });
  }

  public setThingsToDoSeoTags(cityName: string): void {
    const formattedCity = cityName.toLowerCase().replace(/ /g, '-');
    const url = `${this.URL}/things-to-do-in-${formattedCity}`;
    const title = `Things to do in ${cityName}`;
    const description = `Discover the best things to do in ${cityName} with Routeperfect. Explore top attractions, hidden gems, must-see sights, recommended hotels, and local events to make the most of your visit to ${cityName}.`;

    this.setMetaTagsDynamically(cityName, description, title);
    this.linkService.addTag({ rel: 'canonical', href: url });
  }

  public setTripPlannerSeoTags(): void {
    const url = `${this.URL}/trip-planner`;
    const title = `Plan & Optimize Your Perfect Trip with Routeperfect's AI, Classic, & Popular Itinerary Planner`;
    const description = `Plan and book your best trip with Routeperfect's ultimate itinerary planner. Create your perfect tour based on your preferences, budget, and style using AI, classic, or popular itineraries. Our advanced tool optimizes every detail for a flawless journey`;

    this.setMetaTagsDynamically('trip-planner', description, title);
    this.linkService.addTag({ rel: 'canonical', href: url });
  }
}
